<template>
  <div class="partners-box">
    <div class="container">
      <AnimeTitle
        :title="$t('partners.title')"
        svgRefValue="partnersAnimeTitle"
        :computingTitle="$t('partners.computingTitle')"
      />
      <div
        class="secondary-title"
        data-animation="fade-scale-up"
        data-once="false"
      >
        {{ $t('partners.subTitle') }}
      </div>
      <img
        data-animation="fade-scale-up"
        data-once="false"
        src="@/assets/img/pc/partners-icon.png"
        class="partners-icon"
      />
    </div>
  </div>
</template>
<script setup></script>
<style lang="scss" scoped>
.partners-box {
  //设置背景图
  background-image: url('@/assets/img/pc/partners-bg.png');
  //设置背景图大小
  background-size: 100% 100%;
  width: 100%;
  padding: 120px 0;
  .partners-icon {
    width: 100%;
    height: auto;
    margin-top: 60px;
  }
}
</style>
